export { default as StrategyTimeFrame } from './StrategyTimeFrame';
